<template>

	<div class="abow_wbox bkf7">
		<div class="inter">
            <!-- <div class="n_content_ti"><span>{{info.channelInfo.name}}</span> </div> -->
			<div class="de_content_box">

				
				<div class="content_nbox">

                    <div class="show_new_nox">

                        <div class="text" v-html="info.archivesInfo.content"></div>
                    </div>
						
				</div>

			</div>
		</div>
	</div>

</template>


<script>
export default {
	data() {
		return {
            id:0,
            info:{
                archivesInfo:{},
                channelInfo:{}
            }
		}
	},
	created: function (data) {
		  this.getinfo();


	},
	watch: {
		$route() {

		}
	},
	methods: {
		
		getinfo() {
			var that = this;
			this.rq.requests.post("api/game/cms/detail2", {
				id: 5,
			}).then(res => {
				that.info = res.data;
				
			}).catch(error => {

			})
		},




	}


}
</script>